// src/constants/parameterLabels.js

/**
 * Human-readable labels for the backend `Parameter` enum
 * (io.lotto.ai.entity.enums.Parameter) — combinations of moon phase /
 * day-of-month / day-of-week / month used by the number-generation
 * algorithm. The backend has no label map of its own (confirmed while
 * planning the MatchResult reports feature), so this is the single
 * source of truth on the frontend — keep in sync if the enum changes.
 */
export const PARAMETER_LABELS = {
  MOONPHASE:               "Moon phase",
  MOONPHASE_DAY:           "Moon phase + Day",
  MOONPHASE_DOW:           "Moon phase + Weekday",
  MOONPHASE_MONTH:         "Moon phase + Month",
  MOONPHASE_DAY_DOW:       "Moon phase + Day + Weekday",
  MOONPHASE_DAY_MONTH:     "Moon phase + Day + Month",
  MOONPHASE_DAY_DOW_MONTH: "Moon phase + Day + Weekday + Month",
  MOONPHASE_DOW_MONTH:     "Moon phase + Weekday + Month",
  DAY:                     "Day",
  DOW:                     "Weekday",
  MONTH:                   "Month",
  DAY_DOW:                 "Day + Weekday",
  DAY_MONTH:               "Day + Month",
  DAY_DOW_MONTH:           "Day + Weekday + Month",
  DOW_MONTH:               "Weekday + Month",
};

export const PARAMETER_OPTIONS = [
  { value: "", label: "All parameters" },
  ...Object.entries(PARAMETER_LABELS).map(([value, label]) => ({ value, label })),
];

export const parameterLabel = (value) => (value ? PARAMETER_LABELS[value] || value : "—");
